import axios from 'axios';

export const formatDate = (dateAt: string | undefined): string => {
  if (dateAt === undefined) {
    return '';
  }

  const timestamp = Date.parse(dateAt);
  if (isNaN(timestamp)) {
    return '';
  }

  const date = new Date(timestamp);
  const formatter = new Intl.DateTimeFormat('ja', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });

  try {
    return formatter.format(date);
  } catch (error) {
    console.error('Error formatting date:', dateAt, error);
    return 'Invalid date format';
  }
};

export const formatMonth = (inputMonth: string | undefined): string => {
  if (inputMonth === undefined || inputMonth === "") {
    return "";
  }
  const dateParts = inputMonth.split('-');
  const year = dateParts[0];
  const month = dateParts[1];

  return `${year}/${month}`;
}

export const toUnderscoreCase = (str: string) => {
  return str.split(/(?=[A-Z])/).join('_').toLowerCase()
}

export const convertKeysToSnakeCase = (obj: Record<string, any>): Record<string, any> => {
  return Object.keys(obj).reduce((accumulator: Record<string, any>, currentKey: string) => {
    const newKey = toUnderscoreCase(currentKey);
    accumulator[newKey] = obj[currentKey];
    return accumulator;
  }, {});
};

export const fetchAddressData = async (zipcode: string) => {
  try {
    const response = await axios.get(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipcode}`);

    const { data } = response;
    if (data.results && data.results.length > 0) {
      const result = data.results[0];

      return {
        stateId: result.prefcode,
        address1: `${result.address2} ${result.address3}`
      };
    } else {
      return { message: 'No data found for the provided zipcode.' };
    }
  } catch (error) {
    console.error('Error fetching address data:', error);
    return { message: 'Error fetching address data' };
  }
}

export   const getFormattedToday = (includeDay: boolean): string => {
  const today = new Date();

  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();

  if (includeDay) {
    return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
  } else {
    return `${year}-${month.toString().padStart(2, '0')}`;
  }
}